// Socket.io client singleton cho admin_cf (đồng bộ realtime giữa các admin)
import { io } from "socket.io-client";

const SOCKET_URL = "https://backend.hoanglecf.com";
// const SOCKET_URL = "http://localhost:5000";

let socket = null;

export function getSocket() {
  if (!socket) {
    socket = io(SOCKET_URL, {
      // cPanel/Passenger chặn upgrade WebSocket → chỉ dùng polling cho ổn định
      transports: ["polling"],
      upgrade: false,
      reconnection: true,
    });
  }
  return socket;
}
